import { render, staticRenderFns } from "./FractionDisposalPieChart.vue?vue&type=template&id=157f04a1&"
import script from "./FractionDisposalPieChart.vue?vue&type=script&lang=js&"
export * from "./FractionDisposalPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports